// extracted by mini-css-extract-plugin
var _1 = "Form__Form___lHtmA";
var _2 = "Form__animate___AgvFR";
var _3 = "Form__error___tWZcF";
var _4 = "Form__wiggle___GwfJr";
export { _1 as "Form", _2 as "animate", _3 as "error", _4 as "wiggle" }
